import React, { useState } from 'react';
import { useData } from "../../../context/DataContext";
import SingleSelectComponent from "../../../components/Selections/SingleSelectComponent";
import {
    Card,
    CardActions,
    Grid,
    Paper,
    FormLabel,
    FormControlLabel,
    Checkbox,
    Radio, CardHeader,
    TextField, Typography,
    Box, Divider,
    CardContent,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
} from "@mui/material";
import { createSoilReport, updateSoilVillageReport } from "../../../context/createAPI"
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../../components/buttons/customButton';
import SingleSelect from '../../../components/Selections/singleSelect';
import SnackbarMessage from '../../../components/snackBar/snackBar';
import { getClientTheme } from '../../../theme/clientTheme';

const SoilVillageCreation = (villagesArray) => {
    const navigate = useNavigate();
    const { years = [], cropTypes = [], soilTypes = [], user = {}, handleSoilReports, soilReports = [], user_client_id } = useData();
    const yearIndex = years[0]?.value;
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const clientTheme = getClientTheme(user_client_id);


    const [state, setState] = useState({
        selectedVillageValue: '',
        selectedLevelType: 1,
        villageError: "",
        year: yearIndex,
        loading: false,
        submitMessage: "",
        villagesArray: villagesArray.villagesArray,
        soilData: soilTypes.reduce((acc, soil) => {
            acc[soil.value] = { ph: '', ec: '', soc: '', n: '', p: '', k: '' };
            return acc;
        }, {}),
        fertilizerRecommendations: soilTypes.reduce((acc, soil) => {
            acc[soil.value] = cropTypes.map(crop => ({
                cropType: crop.value,
                urea: '',
                dap: '',
                potash: '',
                OrganicManure: ''
            }));
            return acc;
        }, {}),
    });

    const yearsSoilData = soilReports.filter((item) => +item.year_id === +state.year)
    const existingSoilReportVillageData = yearsSoilData.filter((item) => item.report_level_id === 1 && item.year_id === +state.year);

    const handleInputChange = (name, value) => {
        if (name === "selectedVillageValue") {
            const existingVillageData = existingSoilReportVillageData.filter((a) => +a.village_id === +value && a.farmer_id === null);

            setState((prevData) => ({
                ...prevData,
                selectedVillageValue: value,
                villageError: "",
                soilData: soilTypes.reduce((acc, soil) => {
                    const matchingData = existingVillageData.find(item => item.soil_type_id === soil.value);
                    acc[soil.value] = {
                        ph: matchingData ? matchingData.ph : '',
                        ec: matchingData ? matchingData.ec : '',
                        soc: matchingData ? matchingData.oc : '',
                        n: matchingData ? matchingData.n : '',
                        p: matchingData ? matchingData.p : '',
                        k: matchingData ? matchingData.k : '',
                        id: matchingData ? matchingData.id : '',
                    };
                    return acc;
                }, {}),

                fertilizerRecommendations: soilTypes.reduce((acc, soil) => {
                    const matchingRecommendations = existingVillageData.find(item => item.soil_type_id === soil.value);
                    const parseData = typeof matchingRecommendations?.recommendations === "string" ? JSON.parse(matchingRecommendations.recommendations) : matchingRecommendations?.recommendations || [];

                    acc[soil.value] = cropTypes.map(crop => ({
                        cropType: crop.value,
                        urea: parseData ? parseData.find((item) => item.cropType === crop.value)?.urea || '' : '',
                        dap: parseData ? parseData.find((item) => item.cropType === crop.value)?.dap || '' : '',
                        potash: parseData ? parseData.find((item) => item.cropType === crop.value)?.potash || '' : '',
                        OrganicManure: parseData ? parseData.find((item) => item.cropType === crop.value)?.OrganicManure || '' : '',
                    }));

                    return acc;
                }, {}),
            }));
        } else if (name === "year") {
            setState((prevData) => ({
                ...prevData,
                year: value,
            }));
        }
    };


    const handleAnalysisChange = (section, index, field, value) => {
        if (validateNumberInput(value)) {
            const soilType = soilTypes[index].value; // Get the soilType using index
            setState((prevData) => ({
                ...prevData,
                submitMessage: "",
                [section]: {
                    ...prevData[section],
                    [soilType]: {
                        ...prevData[section][soilType],
                        [field]: value,
                    },
                },
            }));
        }
    };


    const handleRecommendationChange = (soilType, index, field, value) => {
        if (validateNumberInput(value)) {
            const recommendations = state.fertilizerRecommendations[soilType];

            if (Array.isArray(recommendations)) {
                const updatedRecommendations = [...recommendations];

                updatedRecommendations[index] = {
                    ...updatedRecommendations[index],
                    [field]: value,
                };

                setState((prevData) => ({
                    ...prevData,
                    fertilizerRecommendations: {
                        ...prevData.fertilizerRecommendations,
                        [soilType]: updatedRecommendations,
                    },
                }));
            } else {
                console.error(`No recommendations found for soilType: ${soilType}`);
            }
        }
    };

    const validateNumberInput = (value) => {
        const regex = /^\d{0,5}(\.\d{0,2})?$/;
        return regex.test(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!state.selectedVillageValue) {
            setState((prevState) => ({
                ...prevState,
                villageError: "Please Select Village"
            }))
            return;
        }
        const emptySoilData = Object.keys(state.soilData).some((soilId) => {
            const soilInfo = state.soilData[soilId];
            return !soilInfo.ph || !soilInfo.ec || !soilInfo.soc || !soilInfo.n || !soilInfo.p || !soilInfo.k;
        });

        if (emptySoilData) {
            setState((prevState) => ({
                ...prevState,
                loading: false,
                submitMessage: "Please fill in all Soil Analysis Fields."
            }));
            return;
        }

        setState((prevState) => ({
            ...prevState,
            loading: true
        }));

        const cropData = Object.keys(state.soilData).map((soilId) => {
            const soilInfo = state.soilData[soilId];
            const recommendations = state.fertilizerRecommendations[soilId] || [];

            return {
                soil_type_id: soilId,
                survey_no: null,
                crop_type_id: null,
                ph: soilInfo.ph,
                ec: soilInfo.ec,
                oc: soilInfo.soc,
                n: soilInfo.n,
                p: soilInfo.p,
                k: soilInfo.k,
                clay_content: null,
                cec: null,
                recommendations: recommendations
            };
        });

        try {
            // Call the API to update data
            let createSoilApi = "";
            if (existingSoilReportVillageData.filter((a) => +a.village_id === +state.selectedVillageValue && a.farmer_id === null).length > 0) {
                createSoilApi = await updateSoilVillageReport({
                    crop_data: Object.keys(state.soilData).map((soilId) => {
                        const soilInfo = state.soilData[soilId];
                        const recommendations = state.fertilizerRecommendations[soilId] || [];
                        return {
                            id: soilInfo.id,
                            ph: soilInfo.ph,
                            ec: soilInfo.ec,
                            oc: soilInfo.soc,
                            n: soilInfo.n,
                            p: soilInfo.p,
                            k: soilInfo.k,
                            recommendations: recommendations
                        };
                    }),
                    updated_by: user.user_id
                });
            } else {
                createSoilApi = await createSoilReport({
                    report_level_id: user.level_id,
                    village_id: state.selectedVillageValue === "" ? null : state.selectedVillageValue,
                    ff_group_id: null,
                    farmer_id: null,
                    crop_data: cropData,
                    target_year: yearIndex,
                    inserted_by: user.user_id
                });
            }
            if (createSoilApi.statusCode === 200) {
                handleSoilReports()
                setState((prevState) => ({
                    ...prevState,
                    loading: false,
                    submitMessage: createSoilApi.data
                }));

                setSnackbar({
                    open: true,
                    message: createSoilApi.data || "Soil Report Submitted Successfully..",
                    severity: "success",
                });

                setTimeout(() => {
                    navigate('/soilReport/history');
                }, 1000);
            } else {
                setState((prevState) => ({
                    ...prevState,
                    loading: false,
                    submitMessage: "Submission failed. Please try again."
                }));
            }
        } catch (error) {
            console.error("Error creating soil report:", error);
            setSnackbar({
                open: true,
                message: error,
                severity: "error",
            });
        }
    };

    return (
        <>
            <Typography variant='h5' mb={1}>Village Details</Typography>

            <Grid container spacing={1} mb={1}>
                {
                    [{ id: 1, name: "selectedVillageValue", label: "Select Village", value: state.selectedVillageValue, options: state.villagesArray, error: state.villageError, type: "select" },
                    { id: 2, label: "Select Year", name: "year", value: years[0]?.value ?? state.year, options: [years[0]], disabled: true, type: "select" }].map((field) => (
                        <Grid item size={{ xs: 12, md: 3 }}>
                            <SingleSelect
                                name={field.name}
                                label={field.label}
                                options={field.options || []}
                                value={field.value}
                                disabled={field.disabled}
                                onChange={handleInputChange}
                                error={field.error}
                                formHelperText={true}
                            />
                        </Grid>
                    ))
                }
            </Grid>

            <Divider sx={{ bgcolor: '#f5f1f1ff' }} />


            <Grid container spacing={2} mt={2}>

                {/* SOIL ANALYSIS */}
                <Grid item size={{ xs: 12, md: 6 }}>
                    <Card>
                        <CardHeader title="Soil Analysis" />
                        <CardContent>
                            <TableContainer component={Paper}
                                sx={{
                                    width: "100%",
                                    maxHeight: "60vh",
                                    overflowX: "auto",        // ✅ horizontal scroll (mobile)
                                    overflowY: "auto",        // ✅ vertical scroll
                                    WebkitOverflowScrolling: "touch",
                                }}
                            >
                                <Table size="small"
                                    sx={{
                                        minWidth: 1000,
                                    }}>
                                    <TableHead sx={{
                                        backgroundColor: clientTheme.activeBg,
                                    }}>
                                        <TableRow>
                                            <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>Soil Type</TableCell>
                                            {["pH", "EC", "SOC", "N", "P", "K"].map((h) => (
                                                <TableCell key={h} align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>{h}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {soilTypes.map((soil, index) => (
                                            <TableRow key={soil.value}>
                                                <TableCell align="center">{soil.label}</TableCell>

                                                {["ph", "ec", "soc", "n", "p", "k"].map((key) => (
                                                    <TableCell key={key} align="center">
                                                        <TextField
                                                            size="small"
                                                            value={state.soilData[soil.value][key]}
                                                            onChange={(e) =>
                                                                handleAnalysisChange("soilData", index, key, e.target.value)
                                                            }
                                                        // inputProps={{ style: { textAlign: "center" } }}
                                                        />
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Grid>

                {/* FERTILIZER RECOMMENDATIONS */}
                <Grid item size={{ xs: 12, md: 6 }}>
                    <Card>
                        <CardHeader title="Fertilizer Recommendations" />
                        <CardContent>

                            {soilTypes.map((soil) => (
                                <Box key={soil.value} mb={3}>
                                    <Typography sx={{ color: "#f0174dff", mb: 1 }}>
                                        {soil.label}
                                    </Typography>

                                    <TableContainer component={Paper}
                                        sx={{
                                            width: "100%",
                                            maxHeight: "60vh",
                                            overflowX: "auto",        // ✅ horizontal scroll (mobile)
                                            overflowY: "auto",        // ✅ vertical scroll
                                            WebkitOverflowScrolling: "touch",
                                        }}
                                    >
                                        <Table size="small"
                                            sx={{
                                                minWidth: 1000,
                                            }}>
                                            <TableHead sx={{
                                                backgroundColor: clientTheme.activeBg,
                                            }}>
                                                <TableRow>
                                                    {["Crop Type", "Urea (N)", "DAP (P)", "Potash (K)", "Organic Manure"]
                                                        .map((h) => (
                                                            <TableCell key={h} align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>{h}</TableCell>
                                                        ))}
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {state.fertilizerRecommendations[soil.value].map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center">
                                                            <TextField
                                                                size="small"
                                                                value={
                                                                    cropTypes.find(c => c.value === row.cropType)?.label || ""
                                                                }
                                                                disabled
                                                                sx={{
                                                                    "& .MuiInputBase-input": {
                                                                        color: "#000",        // value text color
                                                                    },
                                                                    "& .Mui-disabled .MuiInputBase-input": {
                                                                        WebkitTextFillColor: "#000",   // important for disabled
                                                                    },
                                                                    // background for disabled
                                                                    "& .MuiOutlinedInput-root.Mui-disabled": {
                                                                        backgroundColor: "#e5e5e5",      // change to what you want
                                                                    },
                                                                    "& .MuiInputLabel-root": {
                                                                        color: "#000",
                                                                        fontWeight: 700, // thick black
                                                                    },
                                                                }}
                                                            />
                                                        </TableCell>

                                                        {["urea", "dap", "potash", "OrganicManure"].map((key) => (
                                                            <TableCell key={key} align="center">
                                                                <TextField
                                                                    size="small"
                                                                    value={row[key]}
                                                                    onChange={(e) =>
                                                                        handleRecommendationChange(
                                                                            soil.value,
                                                                            index,
                                                                            key,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    inputProps={{ style: { textAlign: "center" } }}
                                                                />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            ))}

                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Box sx={{ textAlign: "center", mt: 2 }}><Typography color='error' variant='body1'>{state.submitMessage}</Typography></Box>
            <CardActions sx={{ justifyContent: "center", mb: 1, mt: 1 }}>
                <CustomButton
                    status={state.loading === true ? "loading" : "idle"}
                    onClick={handleSubmit}
                    label="Add Report"
                    loadingLabel="Submitting.."
                />
            </CardActions>


            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </>
    );
};
export default SoilVillageCreation;